import * as types from './mutation-types'
import Vue from 'vue'
import { IUniteMobileState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbUniteMobile, IAloDbUniteMobileConstParam } from '@/models/alodb/AloDbUniteMobile';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IUniteMobileState> = {
     
    //Gestion des recherches de missions
    [types.UNITEMOBILE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.UniteMobile.Title').toString()}).toString()
        state.uniteMobileLoading = true
    },
    [types.UNITEMOBILE_SUCCESS]: (state, uniteMobiles:Array<AloDbUniteMobile>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.UniteMobile.Title').toString()}).toString()
        state.uniteMobiles = uniteMobiles   
        state.uniteMobileLoading = false             
    },
    [types.UNITEMOBILE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.UniteMobile.Title').toString()}).toString()
        state.uniteMobiles = []
        state.uniteMobileLoading = false
    },
    [types.UNITEMOBILE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.UniteMobile.Title').toString()} ${itemId}`}).toString()
        state.uniteMobileLoading = true
    },
    [types.UNITEMOBILE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.UniteMobile.Title').toString()}).toString()
        state.uniteMobileLoading = false
    },
    [types.UNITEMOBILE_SELECT_DETAIL_SUCCESS]: (state,uniteMobile:AloDbUniteMobile) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.UniteMobile.Title').toString()} ${uniteMobile.UMB_ID}`}).toString()        
        //1, on met à jour de m'uniteMobile dans la liste des uniteMobiles
        const index = state.uniteMobiles.findIndex(m => m.UMB_ID == uniteMobile.UMB_ID)
        state.uniteMobiles.splice(index == -1 ? state.uniteMobiles.length : index, index == -1 ? 0 : 1, uniteMobile)
        state.uniteMobileLoading = false
    },
    [types.UNITEMOBILE_SELECT_DETAIL]: (state,uniteMobile:AloDbUniteMobile) => {                
        state.originalAdmUniteMobile = uniteMobile
        state.modifiedAdmUniteMobile = new AloDbUniteMobile({...uniteMobile,
            UMB_DATADD:uniteMobile.UMB_DATADD? uniteMobile.UMB_DATADD.toUTCString():null,
            UMB_DATSTOP:uniteMobile.UMB_DATSTOP? uniteMobile.UMB_DATSTOP.toUTCString():null} as IAloDbUniteMobileConstParam)
    },
    [types.UNITEMOBILE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.UniteMobile.Title').toString()} ${libelle}`}).toString()
        state.uniteMobileLoading = true
    },
    [types.UNITEMOBILE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.UniteMobile.Title').toString()}).toString()
        state.uniteMobileLoading = false
    },
    [types.UNITEMOBILE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmUniteMobile = {...state.modifiedAdmUniteMobile,...newProperties}
    },
    [types.UNITEMOBILE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    }           
}


export default mutations
